/* Accordion + image: exclusive panels, swap left image from item or default. */
(function () {
  'use strict';

  function setImage(root, item) {
    var img = root.querySelector('.accordion_pwi__img');
    if (!img) return;

    var defaultSrc = root.getAttribute('data-default-src') || '';
    var defaultAlt = root.getAttribute('data-default-alt') || '';
    var itemSrc = item.getAttribute('data-item-image') || '';
    var itemAlt = item.getAttribute('data-item-alt') || '';

    var src = itemSrc || defaultSrc;
    if (src) img.src = src;
    img.alt = itemSrc ? itemAlt : defaultAlt;
  }

  function applyDefaultImage(root) {
    var img = root.querySelector('.accordion_pwi__img');
    if (!img) return;
    var defaultSrc = root.getAttribute('data-default-src') || '';
    var defaultAlt = root.getAttribute('data-default-alt') || '';
    if (defaultSrc) {
      img.src = defaultSrc;
      img.alt = defaultAlt;
    }
  }

  /** Image shown when no panel is open (matches PHP initial / idle state). */
  function applyIdleImage(root) {
    var img = root.querySelector('.accordion_pwi__img');
    if (!img) return;
    var idleSrc = root.getAttribute('data-idle-src') || '';
    var idleAlt = root.getAttribute('data-idle-alt') || '';
    if (idleSrc) {
      img.src = idleSrc;
      img.alt = idleAlt;
      return;
    }
    applyDefaultImage(root);
  }

  function setHeaderTitlesCollapsed(btn) {
    if (!btn) return;
    var shortEl = btn.querySelector('.accordion_pwi__title--short');
    var longEl = btn.querySelector('.accordion_pwi__title--expanded');
    if (shortEl) shortEl.setAttribute('aria-hidden', 'false');
    if (longEl) longEl.setAttribute('aria-hidden', 'true');
  }

  function setHeaderTitlesExpanded(btn) {
    if (!btn) return;
    var shortEl = btn.querySelector('.accordion_pwi__title--short');
    var longEl = btn.querySelector('.accordion_pwi__title--expanded');
    if (!longEl) {
      if (shortEl) shortEl.setAttribute('aria-hidden', 'false');
      return;
    }
    if (shortEl) shortEl.setAttribute('aria-hidden', 'true');
    longEl.setAttribute('aria-hidden', 'false');
  }

  function closeAll(root) {
    root.querySelectorAll('.accordion_pwi__item').forEach(function (node) {
      node.classList.remove('is-open');
      var btn = node.querySelector('.accordion_pwi__header');
      var panel = node.querySelector('.accordion_pwi__panel');
      if (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
        setHeaderTitlesCollapsed(btn);
      }
      if (panel) panel.setAttribute('aria-hidden', 'true');
    });
  }

  function openItem(root, item) {
    closeAll(root);
    item.classList.add('is-open');
    var btn = item.querySelector('.accordion_pwi__header');
    var panel = item.querySelector('.accordion_pwi__panel');
    if (btn) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      setHeaderTitlesExpanded(btn);
    }
    if (panel) panel.setAttribute('aria-hidden', 'false');
    setImage(root, item);
  }

  function init(root) {
    if (root.getAttribute('data-accordion-pwi-init')) return;
    root.setAttribute('data-accordion-pwi-init', '1');

    root.addEventListener('click', function (e) {
      var header = e.target.closest('.accordion_pwi__header');
      if (!header || !root.contains(header)) return;

      e.preventDefault();
      var item = header.closest('.accordion_pwi__item');
      if (!item) return;

      if (item.classList.contains('is-open')) {
        closeAll(root);
        applyIdleImage(root);
        return;
      }
      openItem(root, item);
    });

    var open = root.querySelector('.accordion_pwi__item.is-open');
    if (open) setImage(root, open);
    else applyIdleImage(root);
  }

  function initAll() {
    document.querySelectorAll('[data-accordion-pwi]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
